import JsonLd from "@/components/base/JsonLd";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import CourseHero from "../inscricao/components/CourseHero";
import CourseIncludes from "../inscricao/components/CourseIncludes";
import CourseForWho from "../inscricao/components/CourseForWho";
import EnrollmentForm from "../inscricao/components/EnrollmentForm";
import CourseFAQ from "../inscricao/components/CourseFAQ";

const modules = [
  { number: "01", title: "Introdução da Clientizah" },
  { number: "02", title: "Introdução ao Curso" },
  { number: "03", title: "Conteúdo do Curso" },
  { number: "04", title: "Como ser um Gerente CAT" },
  { number: "05", title: "Conhecimento e Habilidades — Gerente CAT" },
  { number: "06", title: "Inteligência emocional & Autocontrole" },
  { number: "07", title: "Gestão de relacionamento" },
  { number: "08", title: "Rotinas de uma Gerente CAT" },
  { number: "09", title: "Métricas Gerenciais & KPI\'S" },
  { number: "10", title: "Atendimento, Avaliações & Reputação" },
  { number: "11", title: "Métricas & Dicas de VM Gerente CAT" },
  { number: "12", title: "Neurovendas" },
  { number: "13", title: "Experiência para o Cliente CAT" },
  { number: "14", title: "Como contratar talentos" },
  { number: "15", title: "Como reter talentos" },
  { number: "16", title: "Construção de Networking & Aumento das vendas" },
  { number: "17", title: "WhatsApp Business & CRM" },
  { number: "18", title: "Ferramentas de IA para o dia a dia da loja & Mídias virais" },
  { number: "19", title: "Venda com TikTok & TikTok Shop" },
];

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Course",
  name: "Método C.A.T — Gerente",
  description:
    "Para líderes que querem resultados além das metas. Ferramentas, mentalidade e processos que transformam equipes comuns em times de alta performance no varejo.",
  provider: {
    "@type": "Organization",
    name: "Clientizah",
  },
  instructor: {
    "@type": "Person",
    name: "Gleice Lyra",
    jobTitle: "Especialista em Varejo e Liderança",
  },
  timeRequired: "PT30H",
  educationalLevel: "Intermediate",
  inLanguage: "pt-BR",
  offers: {
    "@type": "Offer",
    price: "984.50",
    priceCurrency: "BRL",
    availability: "https://schema.org/LimitedAvailability",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "12000",
    bestRating: "5",
  },
};

export default function InscricaoGerente() {
  const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "";

  return (
    <div className="relative min-h-screen bg-white">
      <title>Método C.A.T Gerente | Curso de Liderança no Varejo | Clientizah</title>
      <meta name="description" content="Curso para gerentes e líderes que querem bater metas, engajar equipes e criar cultura de alta performance. Método C.A.T da Clientizah com Gleice Lyra." />
      <meta name="keywords" content="curso gerente, liderança varejo, KPIs, gestão equipes, Método CAT, Gleice Lyra, Clientizah, curso gerente loja" />
      <link rel="canonical" href={`${siteUrl}/gerente`} />
      <JsonLd data={jsonLd} />
      <Navbar />
      <main className="pt-[160px]">
        <CourseHero
          badge="Vagas Limitadas"
          title="Método C.A.T"
          subtitle="Gerente"
          tagline="Cliente · Atenção · Todo tempo"
          description="Para líderes que querem resultados além das metas. Construída a partir de quase 30 anos de vivência no varejo real, essa trilha entrega as ferramentas, a mentalidade e os processos que transformam equipes comuns em tempos de alta performance. Você terá acesso a todos os módulos da vendedora também. Além de aulas personalizadas todos os meses para implantação do conteúdo."
          hours="+30 horas de conteúdo"
          bgSeq="coursehero-gerente"
        />
        <CourseIncludes modules={modules} totalHours="30" />

        <CourseForWho
          forWho={[
            {
              icon: "ri-user-star-line",
              title: "Vendedoras recém-promovidas a gerente",
              desc: "Assumiu a liderança sem treinamento formal e precisa de método para liderar com segurança e entregar resultados desde o início.",
            },
            {
              icon: "ri-team-line",
              title: "Gerentes que têm dificuldade com a equipe",
              desc: "Sente que a equipe não engaja, não bate metas ou gera conflitos. Quer ferramentas reais para liderar, motivar e cobrar com equilíbrio.",
            },
            {
              icon: "ri-bar-chart-box-line",
              title: "Gestores que querem dominar os números",
              desc: "Precisa entender KPIs, métricas de loja e tomar decisões com base em dados — não só no feeling.",
            },
            {
              icon: "ri-focus-3-line",
              title: "Líderes que querem construir times de alta performance",
              desc: "Quer criar uma cultura de excelência, contratar e reter talentos e transformar sua loja em referência de atendimento.",
            },
          ]}
          notForWho={[
            "Não ocupa e não pretende ocupar um cargo de liderança no varejo.",
            "Busca atalhos sem disposição para aprender a liderar pessoas.",
            "Não tem interesse em acompanhar métricas ou resultados da loja.",
          ]}
        />

        {/* Instructor */}
        <section className="py-16 px-6 md:px-16 bg-white border-t border-gray-100">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
            <div className="w-24 h-24 shrink-0 overflow-hidden rounded-full border-2 border-[#b8962e]/30">
              <img src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/47b68a2a-669a-4028-a55a-db99149e15a8_Gleice.png?v=b1ce88b4ce58c92c6097cac96816f8c8"
                alt="Gleice Lyra" className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <p className="text-xs tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-1">Sua instrutora</p>
              <h3 className="text-black text-xl font-semibold mb-2 tracking-tight">Gleice Lyra</h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-2xl">
                Especialista em varejo, vendas e comportamento do consumidor com mais de 15 anos de experiência transformando equipes em todo o Brasil.
              </p>
            </div>
            <div className="flex flex-col items-center gap-1 shrink-0">
              <span className="text-3xl font-bold text-black">+12k</span>
              <span className="text-xs text-gray-400 tracking-widest uppercase">Alunos formados</span>
            </div>
          </div>
        </section>

        <EnrollmentForm defaultCourseKey="gerente" />
        <CourseFAQ />
      </main>
      <Footer />
    </div>
  );
}
